import { Routes } from '@angular/router';
import { ClientGuard } from '@dss-libs/shared/guard/common-guards';
import { CreateOrganizationComponent } from './create-organization/create-organization.component';
import { InviteMembersComponent } from './invite-members/invite-members.component';

export const createClientRoutes: Routes = [
  {
    path: 'create-organization',
    loadComponent: () => CreateOrganizationComponent,
  },
  {
    path: 'invite-members',
    canActivate: [ClientGuard],
    loadComponent: () => InviteMembersComponent,
  },
  {
    path: '**',
    redirectTo: 'create-organization',
  },
];
